import { render, staticRenderFns } from "./choose-way.vue?vue&type=template&id=4761bd94&scoped=true"
import script from "./choose-way.vue?vue&type=script&lang=js"
export * from "./choose-way.vue?vue&type=script&lang=js"
import style0 from "./choose-way.vue?vue&type=style&index=0&id=4761bd94&prod&lang=scss"
import style1 from "./choose-way.vue?vue&type=style&index=1&id=4761bd94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4761bd94",
  null
  
)

export default component.exports